import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';

const propsSchema = [
  {
    key: 'scrollAnimation',
    label: 'Scroll Animation',
    type: types.BOOLEAN,
  },
  {
    key: 'section_title',
    label: 'Section Title',
    type: types.TEXT
  },
  {
    key: 'news',
    label: 'News',
    type: types.ARRAY,
    children: [
      {
        key: 'logo',
        label: 'Logo Url',
        type: types.TEXT
      },
      {
        key: 'date',
        label: 'Date',
        type: types.DATE
      },
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT
      },
      {
        key: 'url',
        label: 'Url',
        type: types.TEXT
      }
    ]
  },
  {
    key: 'link',
    label: 'Link',
    type: types.OBJECT,
    children: [
      {
        key: 'label',
        label: 'Label',
        type: types.TEXT_WITH_ICON,
        children: [
          { key: 'text', label: 'Text' },
          { key: 'icon', label: 'Icon' },
          { key: 'placement', label: 'Placement' }
        ]
      },
      {
        key: 'url',
        label: 'Url',
        type: types.TEXT
      }
    ]
  }
];

const defaultProps = {
  scrollAnimation: true,
  section_title: 'In The News',
  news: [
    {
      logo: 'https://genesis-cdn.ff.com/press_room/news%20logos/Supercharged%20Logo.jpg',
      date: '2017-07-01T19:51:09.878Z',
      title: 'Faraday Future is joining Formula E',
      url: '/'
    },
    {
      logo: 'https://genesis-cdn.ff.com/press_room/news%20logos/Engadget.pngg',
      date: '2017-06-27T19:51:09.878Z',
      title: 'Faraday Future’s Designer Gets Charged Up about Its All-Electric Supercar',
      url: '/'
    },
    {
      logo: 'https://genesis-cdn.ff.com/press_room/news%20logos/2000px-Los_Angeles_Times_logo.png',
      date: '2017-06-24T19:51:09.878Z',
      title: 'Faraday Future driverless cars to hit California highways',
      url: '/'
    },
    {
      logo: 'https://genesis-cdn.ff.com/press_room/news%20logos/Bloomberg.png',
      date: '2017-05-01T19:51:09.878Z',
      title: 'There’s Way More To Faraday Future Than a Crazy Concept Car',
      url: '/'
    }
  ],
  link: {
    label: {
      text: 'More articles',
      icon: 'ff-icon-long-arrow-right',
      placement: 'AFTER'
    },
    url: '/'
  }
};

export default {
  title: 'In The News',
  id: 'InTheNews',
  propsSchema,
  defaultProps
};
